import Table from "../../components/Table";
import DeprecatedPagination from "../../components/DeprecatedPagination";
import PageHead from "../../components/PageHead";
import {getAxiosInstance} from "../../utils/axiosInstance";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import NewRoleModal from "./RolesComponets/NewRoleModal";
import EditRoleModal from "./RolesComponets/EditRoleModal";

const getRoleColumns = (t: TFunction<any>) => [
  {
    Header: t("CRT_NO"),
    accessor: "no"
  },
  {
    Header: t("Role"),
    accessor: "role"
  },
  {
    Header: t("Permissions"),
    accessor: "permissions"
  }
];

export interface Role {
  id: string;
  no: number;
  role: string;
  permissions: string;
  originalPermissions: string[];
};

interface ApiResponseRole {
  id: string;
  role: string;
  permissions: string[];
};

type ApiResponse = ApiResponseRole[];

const Roles = () => {
  const { t } = useTranslation("translations");
  const permissionTransaltions = useTranslation("permissions");
  
  const [roles, setRoles] = useState<Role[]>([]);
  const [rolesToRender, setRolesToRender] = useState<Role[]>([]);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [newRoleModal, setNewRoleModal] = useState<boolean>(false);

  const [editedRole, setEditedRole] = useState<Role | null>(null);
  
  const transformResponse = (data: ApiResponse): Role[] => {
    const fData: Role[] = [];
    let i = 0;
    for (const d of data) {
      i++;
      fData.push({
        no: i,
        id: d.id,
        role: d.role,
        originalPermissions: d.permissions ?
          typeof(d.permissions) === "string" ? [d.permissions] : d.permissions :
          [],
        permissions: d.permissions.length > 0 ?
          d.permissions.reduce((acum, x) => acum = permissionTransaltions.t(acum) +`, ${permissionTransaltions.t(x)}`) :
          ""
      });
    }
    return fData;
  }

  const fetchData = async (): Promise<Role[]> => {
    setLoadingData(true);
    try {
      const res = await getAxiosInstance().get('/Role');
      setRoles(transformResponse(res.data));
      return transformResponse(res.data);
    } catch (e) {
      toast.error(
        t("SOMETHING_WENT_WRONG"),
        { position: toast.POSITION.BOTTOM_RIGHT }
      );
      return [];
    } finally {
      setLoadingData(false);
    }
  }

  useEffect(() => {
    fetchData().then((x) => setRolesToRender([...x].slice(0, 10)));
  }, []);

  return <div>
    <PageHead
      addTooltip={t("ADD_NEW_ROLE_TOOLTIP")}
      name={t("ROLE_PAGE_TABLE")}
      onAddModal={() => setNewRoleModal(true)}
    />
    <Table
      columns={getRoleColumns(t)}
      data={rolesToRender}
      onRowClick={data => setEditedRole(data)}
      loading={loadingData}
      Pagination={
        <DeprecatedPagination
          dataLegth={roles.length}
          fetchData={(page, perPage) => {
            if(roles.length <= 0) return;
            let tmp = [...roles];
            setRolesToRender(tmp.slice((page - 1) * perPage, page * perPage));
          }}
        />
      }
    />
    
    <NewRoleModal
      isOpen={newRoleModal}
      onClose={() => {
        fetchData().then(x => setRolesToRender(x));
        setNewRoleModal(false);
      }}
    />
    
    <EditRoleModal
      open={!!editedRole}
      role={editedRole}
      onClose={() => {
        setEditedRole(null);
        fetchData().then(x => setRolesToRender(x));
      }}    
    />
  </div>
}

export default Roles;